import React, { useState } from "react";
import VisitorCard from "../../../../widgets/VisitorCard";
import {
  Box,
  Grid,
  Pagination,
  Typography,
  ToggleButtonGroup,
  ToggleButton,
} from "@mui/material";
import ViewListIcon from "@mui/icons-material/ViewList";
import ViewModuleIcon from "@mui/icons-material/ViewModule";
import SearchBar from "../../../../widgets/searchBar";
import CustomCircularP from "../../../../widgets/CustomCircularP";
import FilterDialogMui from "../../../../widgets/FilterDialogMui";
import useApiEp from "../../../../hooks/useApiEp";
const Visitors = ({ type }) => {
  const [page, setPage] = useState(1);
  const [sq, setSq] = useState("");
  const [viewMode, setViewMode] = useState("grid");
  const [openFilter, setOpenFilter] = useState(false);
  const [category, setCategory] = useState("");
  const [selectedCountry, setSelectedCountry] = useState("");
  const [selectedLetter, setSelectedLetter] = useState("");
  const [designation, setDesignation] = useState("");
  const { data, isLoading, isError, error } = useApiEp(
    `/user/get-visitors?type=${
      type ?? ""
    }&page=${page}&sq=${sq}&category=${category}&country=${selectedCountry}&letter=${selectedLetter}&designation=${designation}`
  );
  const onPageChange = (e, page) => {
    setPage(page);
  };
  const onItemSearch = (e) => {
    setSq(e.target.value);
  };
  return (
    <Box
      sx={{
        p: { xs: 2, md: 4 },
        backgroundColor: "#f8fafc",
        minHeight: "100vh",
      }}
    >
      <CustomCircularP show={isLoading} />
      <FilterDialogMui
        selectedCountry={selectedCountry}
        setSelectedCountry={setSelectedCountry}
        selectedHall={category}
        setSelectedHall={setCategory}
        selectedLetter={selectedLetter}
        setSelectedLetter={setSelectedLetter}
        open={openFilter}
        setOpen={setOpenFilter}
        catLabel="Filter by Category"
        categories={[]}
      />
      <Grid
        mt={2}
        mb={2}
        gap={2}
        container
        justifyContent="space-between"
        alignItems="center"
      >
        <Grid item>
          <Typography variant="h5" fontWeight={"bold"}>
            {type === "td" ? "Trade Delegates" : "Visitors List"}
          </Typography>
        </Grid>
        <Grid item xs style={{ flexGrow: 1 }}></Grid>
        <Grid item>
          <SearchBar
            onSearch={onItemSearch}
            label="Search Visitors"
            size="7px"
            boxAlign="inline-flex"
            mystyle={{
              display: "inline-flex",
              backgroundColor: "white",
              width: "276px",
            }}
            cstyle={{ flex: 1 }}
          />
        </Grid>
        <Grid item>
          <SearchBar
            onSearch={(e) => setDesignation(e.target.value)}
            label="Filter Designation"
            size="7px"
            boxAlign="inline-flex"
            mystyle={{
              display: "inline-flex",
              backgroundColor: "white",
              width: "200px",
            }}
          />
        </Grid>
        {/* <Grid item>
          <LoadingButton
            onClick={() => setOpenFilter(true)}
            startIcon={<FilterListIcon />}
            variant="contained"
          >
            Filter
          </LoadingButton>
        </Grid> */}
        <Grid item>
          <ToggleButtonGroup
            value={viewMode}
            exclusive
            onChange={(e, newMode) => {
              if (newMode !== null) setViewMode(newMode);
            }}
            aria-label="view mode"
            size="small"
            sx={{ backgroundColor: "#fff" }}
          >
            <ToggleButton value="grid" aria-label="grid view">
              <ViewModuleIcon />
            </ToggleButton>
            <ToggleButton value="list" aria-label="list view">
              <ViewListIcon />
            </ToggleButton>
          </ToggleButtonGroup>
        </Grid>
      </Grid>
      <Grid container spacing={3}>
        {data?.data?.map((item, index) => (
          <Grid
            item
            xs={12}
            sm={viewMode === "grid" ? 6 : 12}
            md={viewMode === "grid" ? 4 : 12}
            lg={viewMode === "grid" ? 3 : 12}
            key={index}
          >
            <VisitorCard item={item} viewMode={viewMode} />
          </Grid>
        ))}
      </Grid>
      <Box mt={2} mb={2} display={"flex"} justifyContent={"center"}>
        <Pagination
          count={Math.ceil(data?.totalItems / 30)}
          page={page}
          onChange={onPageChange}
          color="primary"
        />
      </Box>
    </Box>
  );
};

export default Visitors;
